import { post, patch } from 'helpers/api';
import { STEPS, STEPS_LABELS } from '../../constants';
import { setImport } from './importer';
import { canSave, getImportRequest, getPaths } from '../selectors';

export const ADD_FILE = 'importRequest/ADD_FILE';
export const addFile = file => ({
  type: ADD_FILE,
  file
});

export const REMOVE_FILE = 'importRequest/REMOVE_FILE';
export const removeFile = file => ({
  type: REMOVE_FILE,
  file
});

export const CHANGE_FIELD = 'importRequest/CHANGE_FIELD';
export const changeField = (field, value) => ({
  type: CHANGE_FIELD,
  field,
  value
});

export const SET_ERRORS = 'importRequest/SET_ERRORS';
export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});

export const REMOVE_ERRORS = 'importRequest/REMOVE_ERRORS';
export const removeErrors = () => ({
  type: REMOVE_ERRORS
});

export const SET_IMPORT_REQUEST = 'importRequest/SET_IMPORT_REQUEST';
export const setImportRequest = importRequest => ({
  type: SET_IMPORT_REQUEST,
  importRequest
});

export const saveRequest = isVerification => (
  (dispatch, getState) => {
    const state = getState();
    if (!canSave(state)) return;

    const paths = getPaths(state);
    const { files, ...importRequest } = getImportRequest(state);
    importRequest.filesAttributes = files;

    return post(paths.createRequest, {
      importRequest
    }).then((response) => {
      const importRequest = response.importRequest;
      dispatch(setImportRequest(importRequest));
      if (isVerification) {
        importRequest.clientImport.statusType = STEPS[STEPS_LABELS.MAP].status;
      }
      dispatch(setImport(importRequest.clientImport));

      return importRequest;
    }).catch((errors) => {
      dispatch(setErrors(errors));
    });
  }
);

export const sentToSupport = () => (
  (_dispatch, getState) => {
    const state = getState();
    if (!canSave(state)) return;

    const paths = getPaths(state);
    const { files, ...importRequest } = getImportRequest(state);
    importRequest.filesAttributes = files;

    return patch(`${paths.importRequest}/${importRequest.id}/support`, {
      importRequest
    });
  }
);
